export default __webpack_public_path__ + "cd5536868ba812100064f67824afd7de.svg";